export default __webpack_public_path__ + "static/media/core_vol0_bg.48670643.jpg";